import { state } from '@/manager/sync/store/state';
import { getters } from '@/manager/sync/store/getters';
import { mutations } from '@/manager/sync/store/mutations';
import { actions } from '@/manager/sync/store/action';

export const sync = {
    state,
    getters,
    actions,
    mutations,
};
